import { render, staticRenderFns } from "./DragPreview.vue?vue&type=template&id=b820b124&scoped=true&"
import script from "./DragPreview.vue?vue&type=script&lang=ts&"
export * from "./DragPreview.vue?vue&type=script&lang=ts&"
import style0 from "./DragPreview.vue?vue&type=style&index=0&id=b820b124&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b820b124",
  null
  
)

export default component.exports